module.exports = __webpack_public_path__ + "static/media/manguera-gris.6d4f1b24.svg";